module.exports = __webpack_public_path__ + "img/Group119.5408a834.png";